import { getAuthenticatedSupabaseClient } from '@/integrations/supabase/client';
import { Circuit } from '@/types/floorPlanViewer';

export const circuitServiceAdapter = {
  async getByFloorPlan(floorPlanId: string): Promise<Circuit[]> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('circuits')
      .select('*')
      .eq('floor_plan_id', floorPlanId)
      .order('sequence_number', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async create(item: Partial<Circuit>): Promise<Circuit> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('circuits')
      .insert(item as any)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async update(id: string, updates: Partial<Circuit>): Promise<Circuit> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { data, error } = await supabase
      .from('circuits')
      .update(updates as any)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id: string): Promise<boolean> {
    const supabase = await getAuthenticatedSupabaseClient();
    const { error } = await supabase
      .from('circuits')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  },
}; 
